"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validateInput = exports.validate = void 0;

/**
 *
 * @param {event} e event received triggered by verification code input
 * @param {number} index index position from the verification code(VC) input array (i.e. digit 1,2,3 etc...)
 * @param {array<html nodes>} inputsArray array which contains every VC digit input (used to change focus on input change)
 */
var validateInput = function validateInput(e, index, inputsArray) {
  var isValid = false;
  var inputNotEmpty = e.target.value.length > 0;

  if (inputNotEmpty) {
    if (validateInputNumber(e) !== null) {
      isValid = true;
      nextInputFocus(inputsArray, index++);
    }
  }

  return isValid ? e.target.value : "";
};
/**
 *
 * @param {event} e event received triggered by verification code input
 * @returns {boolean} if digit is a number
 */


exports.validateInput = validateInput;

var validateInputNumber = function validateInputNumber(e) {
  return (e.target.value || String.fromCharCode(e.keyCode)).match(/[0-9]{1}/);
};
/**
 *
 * @param {array<html nodes>} inputsArray array which contains every VC digit input (used to change focus on input change)
 * @param {number} index index position from the verification code(VC) input array (i.e. digit 1,2,3 etc...)
 * changes focus to next input if digit typed is a number and there wasn't any before
 */


var nextInputFocus = function nextInputFocus(inputsArray, index) {
  var _inputsArray$index;

  var button = document.getElementsByClassName("general-default-button");
  inputsArray !== null && inputsArray !== void 0 && inputsArray.length && index === (inputsArray === null || inputsArray === void 0 ? void 0 : inputsArray.length) ? button[0].focus() : (_inputsArray$index = inputsArray[index]) === null || _inputsArray$index === void 0 ? void 0 : _inputsArray$index.focus();
};
/**
 *
 * @param {array<html nodes>} inputsArray array which contains every VC digit input (used to check if there's any empty)
 * @param {function} setEmptyVerificationCode function to update flag which handles if there's an empty char
 * updates emptyVerificationFlag from father component
 */


var validate = function validate(inputsArray, setEmptyVerificationCode) {
  var contInputEmpty = 0;
  inputsArray.forEach(function (element) {
    element.value === "" ? 0 : contInputEmpty++;
  });
  contInputEmpty === inputsArray.length ? setEmptyVerificationCode(false) : setEmptyVerificationCode(true);
};

exports.validate = validate;